/* Hoggy's Grill: behaviour for the inner pages (class pages, classes list, corporate, catering, story, find us,
   questions). Loaded by the header section on every page except home; each part only wakes up if its section is
   on the page. Heavy libraries (GSAP, MapLibre, three.js) load only when a section that needs them comes near. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var script = document.currentScript;
  var libs = {
    gsap: script && script.dataset.gsap, scrolltrigger: script && script.dataset.scrolltrigger,
    maplibre: script && script.dataset.maplibre, maplibreCss: script && script.dataset.maplibreCss,
    pixel: script && script.dataset.pixel
  };

  var loaded = {};
  function loadScript(src) {
    if (!src) return Promise.reject(new Error('no src'));
    if (loaded[src]) return loaded[src];
    loaded[src] = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
    return loaded[src];
  }
  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(libs.gsap).then(function () { return loadScript(libs.scrolltrigger); })
      .then(function () { window.gsap.registerPlugin(window.ScrollTrigger); });
  }
  function loadPixel() { return window.HgPixel ? Promise.resolve() : loadScript(libs.pixel); }
  // Run fn once el is within `margin` of the screen.
  function whenNear(el, margin, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect(); fn();
    }, { rootMargin: margin + ' 0px' });
    io.observe(el);
  }

  /* ---------- Class day: "Your day at the Test" ----------
     A pinned panel: scrolling moves through the sessions of the day. The scoreboard flips to each session, its course
     card turns over, and along the bottom Hoggy's run-up follows the scroll until the bails come off at stumps. */
  function initDay(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-hg-step]'));
    var board = root.querySelector('[data-hg-board-time]'), boardName = root.querySelector('[data-hg-board-name]');
    var pitchEl = root.querySelector('.hg-day__pitch [data-hg-pixel]');
    if (!steps.length) return;
    var current = -1, pitch = null, L = null;
    function show(i) {
      if (i === current) return;
      current = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); s.classList.toggle('is-past', n < i); });
      var s = steps[i];
      // The scoreboard: the session in big letters, its time underneath when we know it.
      if (board) board.textContent = s.dataset.session || '';
      if (boardName) boardName.textContent = /\d/.test(s.dataset.time || '') ? s.dataset.time : '';
      root.setAttribute('data-hg-day-step', String(i));
    }
    show(0);
    if (reduceMotion) { root.classList.add('is-static'); return; }
    whenNear(root, '400px', function () {
      Promise.all([loadGsap(), loadPixel()]).then(function () {
        root.classList.add('is-pinned');
        if (pitchEl) { pitch = window.HgPixel.mount(pitchEl, { manual: true }); L = pitch && pitch.layout(); }
        window.ScrollTrigger.create({
          trigger: root, start: 'top top', end: '+=' + steps.length * 70 + '%', pin: true, scrub: true,
          onUpdate: function (self) {
            var p = self.progress;
            show(Math.min(steps.length - 1, Math.floor(p * steps.length)));
            if (pitch) { L = L || pitch.layout(); if (L) pitch.at(p * L.end); }
            root.style.setProperty('--hg-day-progress', p.toFixed(4));
          }
        });
      }).catch(function () { root.classList.add('is-static'); });
    });
  }

  /* ---------- The tomahawk: frames from a film sheet, scrubbed by scroll, with a push-in and rising embers ---------- */
  function initTomahawk(root) {
    var canvas = root.querySelector('canvas'), lines = Array.prototype.slice.call(root.querySelectorAll('[data-hg-tline]'));
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d'), sheet = new Image();
    var cols = Number(root.dataset.cols) || 6, count = Number(root.dataset.frames) || 30, fw = Number(root.dataset.fw) || 450, fh = Number(root.dataset.fh) || 800;
    var progress = 0, ready = false;
    function draw() {
      if (!ready) return;
      var w = canvas.clientWidth, h = canvas.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      var f = Math.min(count - 1, Math.floor(progress * count)), sx = (f % cols) * fw, sy = Math.floor(f / cols) * fh;
      var zoom = 1 + 0.35 * progress, cw = canvas.width, ch = canvas.height;
      var scale = Math.max(cw / fw, ch / fh) * zoom, dw = fw * scale, dh = fh * scale;
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(sheet, sx, sy, fw, fh, (cw - dw) / 2, (ch - dh) / 2 - progress * ch * 0.08, dw, dh);
      // embers drifting up through the frame
      for (var i = 0; i < 40; i++) {
        var seed = Math.sin(i * 91.7) * 43758.5, r = seed - Math.floor(seed);
        var x = (r * cw + Math.sin(progress * 6 + i) * 20) % cw, y = ch - ((progress * 1.6 + r) % 1) * ch * 1.1;
        ctx.globalAlpha = 0.35 + 0.5 * r; ctx.fillStyle = i % 3 ? '#ff8a1f' : '#ffd23f';
        ctx.fillRect(x, y, 2 * dpr, 2 * dpr);
      }
      ctx.globalAlpha = 1;
      lines.forEach(function (ln, i) {
        var a = Math.max(0, Math.min(1, (progress - i / lines.length) * lines.length * 1.4));
        ln.style.opacity = a.toFixed(3); ln.style.transform = 'translateY(' + ((1 - a) * 18).toFixed(1) + 'px)';
      });
    }
    whenNear(root, '600px', function () {
      sheet.onload = function () { ready = true; draw(); };
      sheet.src = root.dataset.sheet;
      if (reduceMotion) { progress = 0.6; lines.forEach(function (l) { l.style.opacity = 1; }); return; }
      loadGsap().then(function () {
        window.ScrollTrigger.create({
          trigger: root, start: 'top top', end: '+=180%', pin: true, scrub: true,
          onUpdate: function (self) { progress = self.progress; draw(); root.setAttribute('data-hg-progress', progress.toFixed(2)); }
        });
      }).catch(function () { progress = 0.6; draw(); });
    });
    window.addEventListener('resize', draw);
  }

  /* ---------- The burger rub in 3D (hg-rub3d.js, a module, loads three.js itself) ---------- */
  function initRub(root) {
    whenNear(root, '500px', function () {
      if (reduceMotion) { root.classList.add('is-static'); return; }
      var test = document.createElement('canvas');
      if (!(test.getContext('webgl2') || test.getContext('webgl'))) { root.classList.add('is-static'); return; }
      loadGsap().then(function () {
        var s = document.createElement('script');
        s.type = 'module'; s.src = root.dataset.module;
        document.head.appendChild(s);
      }).catch(function () { root.classList.add('is-static'); });
    });
  }

  /* ---------- Classes list: filters and "Which class is for me?" ---------- */
  function initClasses(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hg-kind]'));
    root.querySelectorAll('[data-hg-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = btn.dataset.hgFilter;
        root.querySelectorAll('[data-hg-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        cards.forEach(function (c) { c.hidden = !(k === 'all' || c.dataset.hgKind === k); });
      });
    });
  }
  function initFinder(root) {
    var answers = {}, qs = Array.prototype.slice.call(root.querySelectorAll('[data-hg-q]'));
    var result = root.querySelector('[data-hg-result]'), restart = root.querySelector('[data-hg-restart]');
    var picks = JSON.parse((root.querySelector('script[type="application/json"]') || {}).textContent || '{}');
    // Focus follows the questions once someone has started; not on page load, which would scroll the page down to here.
    function step(n, focus) {
      qs.forEach(function (q, i) { q.hidden = i !== n; });
      if (focus && qs[n]) { var b = qs[n].querySelector('button'); if (b) b.focus(); }
    }
    function pick() {
      if (answers.who === 'solo') return answers.want === 'seafood' ? 'seafood' : answers.want === 'meat' ? 'meat' : 'intro';
      if (answers.time === 'short' || answers.want === 'burgers') return 'burger';
      if (answers.want === 'seafood') return 'gourmet';
      return answers.want === 'meat' ? 'basic' : 'gourmet';
    }
    qs.forEach(function (q, i) {
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          answers[q.dataset.hgQ] = b.dataset.value;
          if (i < qs.length - 1) return step(i + 1, true);
          var p = picks[pick()];
          qs.forEach(function (x) { x.hidden = true; });
          if (p && result) {
            result.querySelector('[data-hg-r-name]').textContent = p.name;
            result.querySelector('[data-hg-r-line]').textContent = p.line;
            var a = result.querySelector('[data-hg-r-link]'); a.href = p.url;
            result.hidden = false; a.focus();
          }
        });
      });
    });
    if (restart) restart.addEventListener('click', function () { answers = {}; result.hidden = true; step(0, true); });
    step(0, false);
  }

  /* ---------- Maps: "where we've cooked" and "find us", both in the dark brand style ---------- */
  function restyle(style) {
    var colours = { background: '#151311', water: '#1b2326', landuse_residential: '#1a1816', landcover_wood: '#19201a', landuse_park: '#1b221b' };
    style.layers = style.layers.map(function (layer) {
      var id = layer.id;
      layer.paint = layer.paint || {};
      if (id === 'background') layer.paint['background-color'] = colours.background;
      else if (colours[id] && layer.type === 'fill') { delete layer.paint['fill-pattern']; layer.paint['fill-color'] = colours[id]; }
      else if (id === 'waterway') layer.paint['line-color'] = '#1f2b2f';
      else if (id === 'building') {
        return { id: 'building-3d', type: 'fill-extrusion', source: layer.source, 'source-layer': 'building', minzoom: 13,
          paint: { 'fill-extrusion-color': '#2b2622', 'fill-extrusion-height': ['coalesce', ['get', 'render_height'], 6],
                   'fill-extrusion-base': ['coalesce', ['get', 'render_min_height'], 0], 'fill-extrusion-opacity': 0.94 } };
      }
      else if (layer.type === 'line' && /highway_(major|motorway)_inner/.test(id)) layer.paint['line-color'] = '#5a4636';
      else if (layer.type === 'line' && /casing/.test(id)) layer.paint['line-color'] = '#1c1916';
      else if (layer.type === 'line' && /highway_(minor|path)/.test(id)) layer.paint['line-color'] = '#332c27';
      else if (layer.type === 'line' && /railway/.test(id)) layer.paint['line-color'] = '#3a3430';
      else if (layer.type === 'symbol') {
        if (/oneway/.test(id)) { layer.layout = layer.layout || {}; layer.layout.visibility = 'none'; }
        layer.paint['text-color'] = '#cfc6b8'; layer.paint['text-halo-color'] = '#101010';
      }
      return layer;
    });
    return style;
  }
  function withMap(el, build) {
    whenNear(el, '600px', function () {
      var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = libs.maplibreCss; document.head.appendChild(css);
      Promise.all([loadScript(libs.maplibre), fetch(el.dataset.style).then(function (r) { return r.json(); })])
        .then(function (res) { build(restyle(res[1])); })
        .catch(function () { el.classList.add('is-failed'); });
    });
  }
  function initCookedMap(el) {
    var places = JSON.parse(el.querySelector('script[type="application/json"]').textContent);
    var list = el.parentNode.querySelectorAll('[data-hg-place]');
    withMap(el, function (style) {
      var map = new maplibregl.Map({ container: el.querySelector('[data-hg-map-canvas]'), style: style, center: [-1.2, 52.4], zoom: 5.6,
        cooperativeGestures: true, attributionControl: { compact: true } });
      map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
      var markers = places.map(function (p, i) {
        var pin = document.createElement('button');
        pin.type = 'button'; pin.className = 'hg-mpin' + (p.home ? ' is-home' : ''); pin.setAttribute('aria-label', p.name);
        pin.innerHTML = '<span>' + (p.home ? '' : (i)) + '</span>';
        var pop = new maplibregl.Popup({ offset: 18, closeButton: false, maxWidth: '260px' })
          .setHTML('<p class="hg-mpop__when">' + (p.when || '') + '</p><p class="hg-mpop__name">' + p.name + '</p><p class="hg-mpop__line">' + (p.line || '') + '</p>');
        var m = new maplibregl.Marker({ element: pin }).setLngLat([p.lng, p.lat]).setPopup(pop).addTo(map);
        return m;
      });
      map.on('load', function () {
        el.classList.add('is-ready');
        var b = new maplibregl.LngLatBounds();
        places.forEach(function (p) { b.extend([p.lng, p.lat]); });
        map.fitBounds(b, { padding: 60, duration: reduceMotion ? 0 : 2400, maxZoom: 7 });
      });
      list.forEach(function (item) {
        item.addEventListener('click', function () {
          var i = Number(item.dataset.hgPlace), p = places[i];
          map.flyTo({ center: [p.lng, p.lat], zoom: 9, duration: reduceMotion ? 0 : 1600, essential: true });
          markers.forEach(function (m, n) { if (n === i) { if (!m.getPopup().isOpen()) m.togglePopup(); } else if (m.getPopup().isOpen()) m.togglePopup(); });
        });
      });
    });
  }
  function initFindMap(el) {
    var data = JSON.parse(el.querySelector('script[type="application/json"]').textContent);
    withMap(el, function (style) {
      var map = new maplibregl.Map({ container: el.querySelector('[data-hg-map-canvas]'), style: style, center: [data.pub.lng, data.pub.lat],
        zoom: 15.4, pitch: 0, cooperativeGestures: true, attributionControl: { compact: true } });
      map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }), 'top-right');
      var pin = document.createElement('div');
      pin.className = 'hg-pin';
      pin.innerHTML = '<span><img src="' + el.dataset.logo + '" alt="" width="22" height="33"></span>';
      new maplibregl.Marker({ element: pin }).setLngLat([data.pub.lng, data.pub.lat]).addTo(map);
      data.spots.forEach(function (s) {
        var m = document.createElement('div');
        m.className = 'hg-spot hg-spot--' + s.kind; m.innerHTML = '<span>' + (s.kind === 'train' ? 'Rail' : 'P') + '</span>';
        new maplibregl.Marker({ element: m }).setLngLat([s.lng, s.lat])
          .setPopup(new maplibregl.Popup({ offset: 14, closeButton: false }).setHTML('<p class="hg-mpop__name">' + s.name + '</p><p class="hg-mpop__line">' + s.walk + '</p>'))
          .addTo(map);
      });
      map.on('load', function () {
        map.addSource('walk', { type: 'geojson', data: { type: 'Feature', geometry: { type: 'LineString', coordinates: data.route } } });
        map.addLayer({ id: 'walk', type: 'line', source: 'walk', layout: { 'line-cap': 'round', 'line-join': 'round' },
          paint: { 'line-color': '#e08000', 'line-width': 4, 'line-dasharray': [0.6, 1.6] } });
        el.classList.add('is-ready');
        var seen = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          seen.disconnect();
          map.flyTo({ center: [data.pub.lng - 0.0012, data.pub.lat + 0.0006], zoom: 16.2, pitch: 58, bearing: -24, duration: reduceMotion ? 0 : 4200, essential: true });
        }, { threshold: 0.4 });
        seen.observe(el);
      });
    });
  }

  /* ---------- Story chapters: each one slides in as it arrives ---------- */
  function initReveal() {
    var items = document.querySelectorAll('[data-hg-reveal]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Questions: filter as you type ---------- */
  function initFaqSearch(root) {
    var input = root.querySelector('[data-hg-faq-search]'), none = root.querySelector('[data-hg-faq-none]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hg-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-hg-faq-group]'));
    if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), shown = 0;
      items.forEach(function (it) { var hit = !q || it.textContent.toLowerCase().indexOf(q) > -1; it.hidden = !hit; if (hit) shown++; if (q && hit) it.open = true; });
      groups.forEach(function (g) { g.hidden = !root.querySelector('[data-hg-faq-item][data-group="' + g.dataset.hgFaqGroup + '"]:not([hidden])'); });
      if (none) none.hidden = shown > 0;
    });
  }

  /* ---------- Recipes: keep the screen awake while you cook ---------- */
  function initCookMode(btn) {
    if (!('wakeLock' in navigator)) { btn.hidden = true; return; }
    var lock = null;
    btn.addEventListener('click', function () {
      if (lock) { lock.release(); lock = null; btn.setAttribute('aria-pressed', 'false'); btn.textContent = 'Cook mode: keep my screen on'; return; }
      navigator.wakeLock.request('screen').then(function (l) {
        lock = l; btn.setAttribute('aria-pressed', 'true'); btn.textContent = 'Cook mode is on';
        l.addEventListener('release', function () { lock = null; btn.setAttribute('aria-pressed', 'false'); btn.textContent = 'Cook mode: keep my screen on'; });
      }).catch(function () {});
    });
  }

  /* ---------- Films that wait for a tap (the story film has sound) ---------- */
  function initFilm(root) {
    var v = root.querySelector('video'), b = root.querySelector('[data-hg-film-play]');
    if (!v || !b) return;
    b.addEventListener('click', function () { root.classList.add('is-playing'); v.controls = true; v.play(); });
  }

  /* ---------- The "film coming soon" strip: our reels load and play once near (stay still with reduced motion) ---------- */
  function initTrailer(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('video[data-src]'));
    if (!vids.length || reduceMotion) { vids.forEach(function (v) { v.removeAttribute('autoplay'); }); return; }
    whenNear(root, '200px', function () {
      vids.forEach(function (v) { v.src = v.dataset.src; v.removeAttribute('data-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    });
  }

  /* ---------- Pixel scenes on these pages (stadium, little corporate scenes, empty cart) ---------- */
  function initPixels() {
    var stadiums = document.querySelectorAll('[data-hg-stadium]');
    stadiums.forEach(function (el) { whenNear(el, '400px', function () { loadPixel().then(function () { window.HgPixel.stadium(el); }); }); });
  }

  // The team cards: three photos each. Swipe (or scroll) the strip; arrows and dots step through it.
  function initDeck(root) {
    var track = root.querySelector('[data-hg-deck-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hg-deck-dot]'));
    var prev = root.querySelector('[data-hg-deck-prev]'), next = root.querySelector('[data-hg-deck-next]');
    if (!track) return;
    var count = track.children.length, current = 0;
    function show(i) {
      current = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === count - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      show(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { show(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
    }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    show(0);
  }

  // "Ask about this" on a feature card: jump to the enquiry form with that option already picked.
  function initAsk() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-hg-ask]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      var select = target && target.querySelector('select[name="contact[Format]"]');
      if (!select) return;
      var want = link.getAttribute('data-hg-ask');
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].text === want) { select.selectedIndex = i; break; }
      }
      setTimeout(function () { select.focus({ preventScroll: true }); }, 450);
    });
  }

  function init() {
    document.querySelectorAll('[data-hg-day]').forEach(initDay);
    document.querySelectorAll('[data-hg-tomahawk]').forEach(initTomahawk);
    document.querySelectorAll('[data-hg-rub]').forEach(initRub);
    document.querySelectorAll('[data-hg-classes]').forEach(initClasses);
    document.querySelectorAll('[data-hg-finder]').forEach(initFinder);
    document.querySelectorAll('[data-hg-cooked-map]').forEach(initCookedMap);
    document.querySelectorAll('[data-hg-find-map]').forEach(initFindMap);
    document.querySelectorAll('[data-hg-faq]').forEach(initFaqSearch);
    document.querySelectorAll('[data-hg-cookmode]').forEach(initCookMode);
    document.querySelectorAll('[data-hg-film]').forEach(initFilm);
    document.querySelectorAll('.hg-ph__trailer.is-placeholder').forEach(initTrailer);
    initReveal();
    initPixels();
    initAsk();
    document.querySelectorAll('[data-hg-deck]').forEach(initDeck);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
